import { render, staticRenderFns } from "./ac2.vue?vue&type=template&id=1854a414&scoped=true&"
import script from "./ac2.vue?vue&type=script&lang=js&"
export * from "./ac2.vue?vue&type=script&lang=js&"
import style0 from "./ac2.vue?vue&type=style&index=0&id=1854a414&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1854a414",
  null
  
)

export default component.exports